import { Paper, Typography, Box } from "@mui/material";
import React from "react";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "../../../components/hook-form";

import { LoadingButton } from "@mui/lab";
import { useSelector, useDispatch } from "react-redux";
import EntityTable from "../../AdminView/EntityTable";
import {
  ComponentType,
  RegistrationStatus,
  UserType,
} from "../../../common/enum";

import ActionComponentRenderer from "../../AdminView/EntityTable/ActionComponentRenderer";
import {
  getManagerInviteList,
  register,
  setManagerType,
} from "../../../redux/features/authSlice";
import { updateRegistrationDetail } from "../../OnBoarding/slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../AdminView/adminSlice";
import ManageManagersTable from "./ManageManagersTable";
import { useSnackbar } from "notistack";
import ManageUsers from "../../../components/ManageBranch/ManageUsers";

const ManageManager = ({ t, editFromEstablishment , estado}) => {
  const dispatch = useDispatch();
  const {
    auth: {
      profile: { entity, status },
      managerInviteCount,
      managerInviteOffset,
      managerInviteLimit,
      managerInviteEntities,
      managerInvitePage,
    },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const columnDefs = [
    {
      headerName: "E-mail",
      field: "email",
    },
    {
      headerName: t("status"),
      field: "status",
    },
    {
      headerName: t("action"),
      cellRenderer: ActionComponentRenderer,
      colId: "params",
      editable: false,
      filter: false,
      sortable: false,
      cellRendererParams: { value: ComponentType.MANAGE_MANGERS },
    },
  ];

  const inviteManagerSchema = Yup.object().shape({
    inviteManagerEmail: Yup.string()
      .email()
      .required(`Campo E-mail de utilizador é de preenchimento obrigatório`),
  });

  const { loading } = useSelector((state) => state);

  const defaultValues = {
    inviteManagerEmail: "",
  };

  const methods = useForm({
    resolver: yupResolver(inviteManagerSchema),
    defaultValues,
  });

  const { handleSubmit } = methods;

  const onSubmit = async () => {
    const value = methods.getValues();
    const data = {
      email: value?.inviteManagerEmail.toLowerCase(),
      password: "Test1234@",
      userType: UserType.entityManager,
      status: RegistrationStatus.registering,
      createdBy: null,
    };
    dispatch(setManagerType("mangeManager"));
    await dispatch(register({ data }))
      .unwrap()
      .then((res) => {
        const payload = {
          userId: res.userId,
          status: RegistrationStatus.invited,
          inviteStatus: "SENT",
          branchEntityId: entity.entityId,
        };
        dispatch(updateRegistrationDetail(payload))
          .unwrap()
          .then(() => {
            dispatch(setManagerType(""));
            const data = {
              limit: managerInviteLimit,
              offset: managerInviteOffset,
              id: entity.id,
            };
            enqueueSnackbar({
              message: t("inviteManagerSuccess"),

              variant: "success",
            });

            dispatch(getManagerInviteList(data));
          })
          .catch((error) => {
            enqueueSnackbar({
              message: t("somethingWentWrong"),

              variant: "error",
            });
          });
      })
      .catch((error) => {
        //console.log(error);
        // alert("unable to invite");
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  };

  return (
    <Paper elevation={4} sx={{ p: 1 }}>
      <Typography variant="h2" style={{fontSize:"24px", color:"text.secondary"}} gutterBottom>
        {t("inviteManager")}
      </Typography>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "flex" }}>
          <RHFTextField
            id="outlined-basic"
            label={t("inviteManagerEmail")}
            variant="outlined"
            name="inviteManagerEmail"
            fullWidth
          />
          <LoadingButton
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            sx={{ ml: 2, borderRadius: "4px" , height: "fit-content", textAlign: "center", marginTop:"5px"}}
            disabled={
              status === RegistrationStatus.inActive || estado === RegistrationStatus.inActive ||
              status === RegistrationStatus.inAtivo || estado === RegistrationStatus.inAtivo ||
              estado === "INVITED"
            }
          >
            {t("invite")}
          </LoadingButton>
        </Box>
      </FormProvider>
      <br />
      {editFromEstablishment !== undefined ? 
        <ManageManagersTable t={t} />
       : 
        <ManageUsers t={t} />
      }
    </Paper>
  );
};

export default ManageManager;
